//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { BVSamplingProduct } from '@apis/campaign-requests/sampling/products/samplingProductsApiModel';

export interface BVSamplingProductWithIsMissingDetails
  extends BVSamplingProduct {
  isMissingDetails: boolean;
}

export enum ReviewProductCardStatus {
  Default = 'default',
  MissingInfo = 'missing-info',
  Incomplete = 'incomplete',
  Complete = 'complete',
}
